<div class="play-icon-overlay">
  <div class="play-icon-container">
    <div class="play-icon"></div>
    <div class="play-icon-active"></div>
  </div>
</div>
